var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPending1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 149,
    viewBox: "0 0 149 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.8319 134.817C107.959 134.498 134.796 107.138 134.477 74.0108C134.158 40.8832 106.798 14.0463 73.6709 14.3656C40.5434 14.6849 13.7064 42.0442 14.0257 75.1717C14.345 108.299 41.7043 135.136 74.8319 134.817ZM73.5583 2.68401C113.104 2.30286 145.777 34.3526 146.159 73.8982C146.54 113.444 114.49 146.117 74.9445 146.498C35.3989 146.88 2.72532 114.83 2.34417 75.2843C1.96302 35.7388 34.0128 3.06516 73.5583 2.68401Z",
    fill: "#F8CA50",
    stroke: "white",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4513 78.2615L67.0916 40.9483L76.1028 40.8615L76.4045 72.1607L76.4101 72.7491L76.9272 73.0298L109.27 90.5923L105.152 98.4203L67.4513 78.2615Z",
    fill: "#F8CA50",
    stroke: "white",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending1);
export default __webpack_public_path__ + "static/media/Pending1.bab7e1f6a2f2d866d7770cd783a72a9f.svg";
export { ForwardRef as ReactComponent };